import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const TriangleWarningIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="alert-triangle" {...props} />;
};

export { TriangleWarningIcon };
